import createBaseService from "@/api/base-service";
import type { Pagination } from "@/api/base-service";

export interface UserAuditLog {
	id: string;
	user_id: string;
	user?: {
		id: string;
		first_name: string;
		last_name: string;
		email: string;
	};
	action: string;
	description: string;
	ip_address: string;
	user_agent: string;
	metadata?: Record<string, any>;
	created_at: string;
	updated_at: string;
}

export interface UserAuditLogResponse {
	data: UserAuditLog[];
	meta: Pagination;
}

const userAuditLogService = {
	...createBaseService<UserAuditLog>("/user-audit-logs"),
};

export default userAuditLogService;
